<template>
<div class="flex flex-col h-full">
  <!-- header -->
  <div class="bg-red-500 text-white shadow-md">
    <div class="container mx-auto">
      <div class="flex items-baseline justify-between py-4 px-4">
        <div class="bg-red-500 text-white text-2xl font-semibold">Praksispoolen</div>
        <div class="flex items-baseline">
          <slot name="nav"/>
          <button @click="onLogout" title="Logg ut" class="ml-2 bg-white xinline py-1 px-2 uppercase rounded text-gray-700 shadow-md hover:shadow-lg focus:outline-none">
            <font-awesome-icon :icon="['far', 'power-off']" class="text-sm" />
          </button>
        </div>
      </div>
    </div>
    <slot name="mobilenav"/>
  </div>

  <!-- content -->
  <div class="h-full overflow-y-scroll">
    <div class="h-full container mx-auto">
      <div class="h-full p-4 pt-12">
        <slot />
      </div>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: 'layout',
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
      this.$router.push('/innlogging')
    }
  }
}
</script>